import { Routes, Route } from 'react-router-dom';
import { HomePage } from '@/pages/HomePage';
import { ClinicPage } from '@/pages/ClinicPage';
import { WelcomePage } from '@/pages/WelcomePage';
import { PatientVisitPage } from '@/pages/PatientVisitPage';
import { PatientInfoPage } from '@/pages/PatientInfoPage';
import { EstimatedBalancePage } from '@/pages/EstimatedBalancePage';
import { PatientServicePage } from '@/pages/PatientServicePage';
import { TestimonialPage } from '@/pages/TestimonialPage';
import { ProviderSelectPage } from '@/pages/ProviderSelectPage';
import { DateSelectPage } from '@/pages/DateSelectPage';
import { AppointmentConfirmationPage } from '@/pages/AppointmentConfirmationPage';
import { InsurancePage } from '@/pages/InsurancePage';
import { ChatPage } from '@/pages/ChatPage';
import { BasicInfoPage } from '@/pages/BasicInfoPage';
import { ContactInfoPage } from '@/pages/ContactInfoPage';
import { RequestSubmittedPage } from '@/pages/RequestSubmittedPage';
import { InsuranceInfoPage } from '@/pages/InsuranceInfoPage';
import { InsuranceDetailsPage } from '@/pages/InsuranceDetailsPage';
import { ToastProvider } from '@/contexts/ToastContext';
import AnimatedLayout from '@/components/AnimatedLayout';
import { ClinicConfigProvider } from '@/contexts/ClinicConfigContext';
import ThemeInitializer from '@/components/ThemeInitializer';
import ClinicPageLayout from '@/components/ClinicPageLayout';

function App() {
  return (
    <ToastProvider>
      <div className='App h-screen w-screen relative overflow-hidden md:overflow-hidden'>
        <Routes>
          <Route element={<AnimatedLayout />}>
            <Route path='/' element={<HomePage />} />
            <Route
              path='/:clinicSlug/*'
              element={
                <ClinicConfigProvider>
                  <ThemeInitializer />
                  <Routes>
                    <Route index element={<WelcomePage />} />
                    <Route element={<ClinicPageLayout />}>
                      <Route path='clinic' element={<ClinicPage />} />
                      <Route
                        path='patient-visit'
                        element={<PatientVisitPage />}
                      />
                      <Route
                        path='patient-info'
                        element={<PatientInfoPage />}
                      />
                      <Route path='basic-info' element={<BasicInfoPage />} />
                      <Route
                        path='contact-info'
                        element={<ContactInfoPage />}
                      />
                      <Route
                        path='request-submitted'
                        element={<RequestSubmittedPage />}
                      />
                      <Route
                        path='estimated-balance'
                        element={<EstimatedBalancePage />}
                      />
                      <Route
                        path='patient-service'
                        element={<PatientServicePage />}
                      />
                      <Route path='testimonial' element={<TestimonialPage />} />
                      <Route
                        path='provider-select'
                        element={<ProviderSelectPage />}
                      />
                      <Route path='date-select' element={<DateSelectPage />} />
                      <Route
                        path='appointment-confirmation'
                        element={<AppointmentConfirmationPage />}
                      />
                      <Route
                        path='insurance-info'
                        element={<InsuranceInfoPage />}
                      />
                      <Route
                        path='insurance-details'
                        element={<InsuranceDetailsPage />}
                      />
                      <Route path='insurance' element={<InsurancePage />} />
                      <Route path='chat' element={<ChatPage />} />
                    </Route>
                  </Routes>
                </ClinicConfigProvider>
              }
            />
          </Route>
        </Routes>
      </div>
    </ToastProvider>
  );
}

export { App };
export default App;
